<template>
  <div
    class="flex flex-col md:flex-row md:items-center md:justify-between gap-4"
  >
    <h3 class="font-bold text-2xl">
      <slot />
    </h3>

    <div v-if="$slots.right" class="w-full md:w-auto">
      <slot name="right" />
    </div>
  </div>
</template>
